import { Box } from "@mui/material";
import { useParams } from "react-router";
import RoleModule from "./RoleModule";
import { useMemo } from "react";

function RoleModuleScreen() {
    const { id } = useParams();
    const baseFilters = useMemo(() => [{
        field: "RoleId",
        operator: "equals",
        value: parseInt(id),
        type: "number"
    },
    {
        field: "IsDisplay",
        operator: "equals",
        value: true,
        type: "boolean"
    }], [id]);
    return (
        <Box>
            <RoleModule.Grid baseFilters={baseFilters} />
        </Box>
    );
}

export default RoleModuleScreen;